/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse, InvoiceFailure, InvoiceFailureRerun } from '@core/models';
import { ApiService } from '@core/services';

@Injectable({
  providedIn: 'root',
})
export class InvoiceFailureService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  /**
   * Get Invoice failures that has to be rerun for a specific client.
   *
   * @type {number} clientId - Client id
   */
  getInvoiceFailuresByClientId(clientId: number): Observable<ApiResponse<InvoiceFailure[]>> {
    return this.http.get<ApiResponse<InvoiceFailure[]>>(
      `${this.apiService.superAdminApi}/saas-invoice-failure/${clientId}`
    );
  }

  /**
   * Recreate invoice for invoice generation failures.
   *
   * @type invoiceFailures - array of failures
   */
  rerunCreateInoviceFailures(
    clientId: number,
    invoiceFailures: InvoiceFailure[]
  ): Observable<ApiResponse<InvoiceFailureRerun>> {
    return this.http.post<ApiResponse<InvoiceFailureRerun>>(
      `${this.apiService.superAdminApi}/saas-invoice-failure/create/${clientId}`,
      invoiceFailures
    );
  }
}
